module.exports = __webpack_public_path__ + "static/media/chfPatient_meals_intro.c1427c4a.png";